import moment from 'moment';
import { TimeConversions, ValueOf } from '../config/constants';
import { config } from '../config/config';

const generateChartDataParams = (
    timeframe: ValueOf<typeof config.areaChartTimeframes>
) => {
    switch (timeframe) {
        case '1d':
            return {
                startTime: moment().subtract(1, 'day').unix(),
                amountToGenerate: TimeConversions.HOURS_PER_DAY,
                timeInterval: TimeConversions.SECONDS_PER_HOUR,
            };
        case '1w':
            return {
                startTime: moment().subtract(1, 'week').unix(),
                amountToGenerate: TimeConversions.DAYS_PER_WEEK,
                timeInterval: TimeConversions.SECONDS_PER_DAY,
            };
        case '1m':
            return {
                // adding 1 day buffer because without it no data is shown, most likely due to time interval / amount to generate
                startTime: moment().add(1, 'day').subtract(1, 'month').unix(),
                amountToGenerate: TimeConversions.DAYS_PER_MONTH,
                timeInterval: TimeConversions.SECONDS_PER_DAY,
            };
        default:
            return {
                startTime: moment().subtract(1, 'year').unix(),
                amountToGenerate: TimeConversions.WEEK_PER_YEAR,
                timeInterval: TimeConversions.SECONDS_PER_WEEK,
            };
    }
};

export default generateChartDataParams;
